<template>
  <app-content class="h-panel">
    <div class="flex justify-between mx-16px pt-16px">
      <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
        <div v-if="params.start!==params.end">{{ fqFormat(params.start) }} 至 {{ fqFormat(params.end) }}</div>
        <div v-else>{{ fqFormat(params.start) }}</div>
        <template #content>
          <Form style="padding: 10px;width: 400px">
            <FormItem class="!pb-5px" label="会计期间">
              <div class="flex items-center">
                <Select @change="dateCheck" v-model="params.start" :deletable="false" filterable :datas="checkoutSelect"/>
                <span class="mx-8px">至</span>
                <Select @change="dateCheck" v-model="params.end" :deletable="false" filterable :datas="checkoutSelect"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px" label="起始科目">
              <Select :datas="subjectList" :filter="sfilter" keyName="code" titleName="fullName"
                      v-model="params.subjectStart">
                <template #show="{value}">
                  {{ value.code }} {{ value.fullName }}
                </template>
                <template #item="{item}">
                  {{ item.code }} {{ item.fullName }}
                </template>
              </Select>
            </FormItem>
            <FormItem class="!pb-5px" label="结束科目">
              <Select :datas="subjectList" :filter="sfilter" keyName="code" titleName="fullName"
                      v-model="params.subjectEnd">
                <template #show="{value}">
                  {{ value.code }} {{ value.fullName }}
                </template>
                <template #item="{item}">
                  {{ item.code }} {{ item.fullName }}
                </template>
              </Select>
            </FormItem>
            <FormItem class="!pb-5px" label="科目级别">
              <div class="flex items-center">
                <Select v-model="params.levelStart" :deletable="false" filterable :datas="[1,2,3,4]"/>
                <span class="mx-8px">至</span>
                <Select v-model="params.levelEnd" :deletable="false" filterable :datas="[1,2,3,4]"/>
              </div>
            </FormItem>
            <!-- //格式化数量 -->
            <FormItem class="!pb-5px" label="数量小数">
              <div class="flex items-center">
                <div><Radio v-model="quantityRadio" :datas="quantity" @change="changeQuantityRadio"></Radio></div>
              </div>
            </FormItem>
            <FormItem class="!pb-5px">
              <Button color="primary" @click="loadList();" :loading="loading">确定</Button>
              <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
              <Button @click="resetForm">重置</Button>
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div class="float-right flex items-center">
        <Checkbox class="mr-16px" v-model="showNum">显示数量</Checkbox>
        <Checkbox :disabled="showYearTotalDis" class="mr-16px" v-model="showYearTotal">显示本年累计</Checkbox>
        <Checkbox class="mr-16px" @change="processFilter" v-model="isBalanceZero">余额为0不显示</Checkbox>
        <Checkbox class="mr-16px" @change="processFilter" v-model="isBalanceZeroAndOccur">无发生额且余额为0不显示</Checkbox>
        <!-- <Checkbox class="mr-16px" v-model="showNumPrice">显示数量金额</Checkbox> -->
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
      </div>
    </div>
    <div class="text-center mb-16px font-bold text-20px">{{ title }} 科目余额表</div>
    <div class="h-panel-body">
      <!--  :tree-config="{transform: true, rowField: 'treeId', parentField: 'parentTreeId',expandAll: true,reserve: true}" -->
      <!--                  是否可以手动展开子节点                                                      默认展开所有节点 reserve是保持节点展开，但是不好用 -->
      <div style="overflow-x: auto;flex: 1;height: calc(100vh - 290px)" class="mr-8px">
      <vxe-table :show-overflow="false"
                 :tree-config="{transform: false, rowField: 'treeId', parentField: 'parentTreeId',expandAll: true}"
                 show-footer
                 height="auto" 
                 :footer-method="calcTotal"
                 :loading="loading" ref="xTable" :data="dataList" border v-if="!showYearTotal && !showNum">
        <vxe-column title="科目编码" field="subjectCode" fixed="left" tree-node width="20%"></vxe-column>
        <vxe-column title="科目名称" field="subjectName" fixed="left" width="20%">
          <!-- //科目余额跳转明细 -->
          <template #default="{row}">
            <router-link class="text-hover primary-color" @success="loadList()" width="1400px"
                          v-if="row.subjectId"
                          :to="{name:'DetailedAccounts',params:{subjectIds:row.subjectId,start:params.start,end:params.end}}">
              {{ row.subjectName }}
            </router-link>
          </template>
        </vxe-column>
        <vxe-colgroup title="期初余额" align="center">
          <vxe-column title="借方" field="beginningDebitBalance" align="right" width="10%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ numFormat(row.beginBalance) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方" field="beginningCreditBalance" align="right" width="10%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ numFormat(row.beginBalance) }}</span>
            </template>
          </vxe-column>
        </vxe-colgroup>
        <vxe-colgroup title="本期发生额" align="center">
          <vxe-column title="借方" field="debit" align="right" formatter="toMoney" width="10%"/>
          <vxe-column title="贷方" field="credit" align="right" formatter="toMoney" width="10%"/>
        </vxe-colgroup>
        <!-- <vxe-colgroup title="本年累计发生额" align="center">
          <vxe-column title="借方" field="yearTotalDebit" align="right" formatter="toMoney" width="120"/>
          <vxe-column title="贷方" field="yearTotalCredit" align="right" formatter="toMoney" width="120"/>
        </vxe-colgroup> -->
        <vxe-colgroup title="期末余额" align="center">
          <vxe-column title="借方" field="endingDebitBalance" align="right"
                      :class-name="({row})=>row.endBalance<0?'red-color':''" width="10%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ numFormat(row.endBalance) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方" field="endingCreditBalance" align="right"
                      :class-name="({row})=>row.endBalance<0?'red-color':''" width="10%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ numFormat(row.endBalance) }}</span>
            </template>
          </vxe-column>
        </vxe-colgroup>
      </vxe-table>
      <vxe-table :show-overflow="false"
                 :tree-config="{transform: false, rowField: 'treeId', parentField: 'parentTreeId',expandAll: true}"
                 show-footer
                 height="auto" 
                 :footer-method="calcTotal"
                 :loading="loading" ref="xTable" :data="dataList" border v-if="showYearTotal && !showNum">
        <vxe-column title="科目编码" field="subjectCode" fixed="left" tree-node width="20%"></vxe-column>
        <vxe-column title="科目名称" field="subjectName" fixed="left" width="20%">
          <!-- //科目余额跳转明细 -->
          <template #default="{row}">
            <router-link class="text-hover primary-color" @success="loadList()" width="1400px"
                          v-if="row.subjectId"
                          :to="{name:'DetailedAccounts',params:{subjectIds:row.subjectId,start:params.start,end:params.end}}">
              {{ row.subjectName }}
            </router-link>
          </template>
        </vxe-column>
        <vxe-colgroup title="期初余额" align="center">
          <vxe-column title="借方" field="beginningDebitBalance" align="right" width="7.5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ numFormat(row.beginBalance) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方" field="beginningCreditBalance" align="right" width="7.5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ numFormat(row.beginBalance) }}</span>
            </template>
          </vxe-column>
        </vxe-colgroup>
        <vxe-colgroup title="本期发生额" align="center">
          <vxe-column title="借方" field="debit" align="right" formatter="toMoney" width="7.5%"/>
          <vxe-column title="贷方" field="credit" align="right" formatter="toMoney" width="7.5%"/>
        </vxe-colgroup>
        <vxe-colgroup title="本年累计发生额" align="center">
          <vxe-column title="借方" field="yearTotalDebit" align="right" formatter="toMoney" width="7.5%"/>
          <vxe-column title="贷方" field="yearTotalCredit" align="right" formatter="toMoney" width="7.5%"/>
        </vxe-colgroup>
        <vxe-colgroup title="期末余额" align="center">
          <vxe-column title="借方" field="endingDebitBalance" align="right"
                      :class-name="({row})=>row.endBalance<0?'red-color':''" width="7.5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ numFormat(row.endBalance) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方" field="endingCreditBalance" align="right"
                      :class-name="({row})=>row.endBalance<0?'red-color':''" width="7.5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ numFormat(row.endBalance) }}</span>
            </template>
          </vxe-column>
        </vxe-colgroup>
      </vxe-table>
      <!-- 格式化数量  一种通过formatQuantity(row.beginQuantity) 另一种 :formatter="['toQuantity', quantityRadio]" -->
      <vxe-table :show-overflow="false"
                 :tree-config="{transform: false, rowField: 'treeId', parentField: 'parentTreeId',expandAll: true}"
                 show-footer
                 height="auto" 
                 :footer-method="calcTotal"
                 :loading="loading" ref="xTable" :data="dataList" border v-if="!showYearTotal && showNum">
        <vxe-column title="科目编码" field="subjectCode" fixed="left" tree-node width="10%"></vxe-column>
        <vxe-column title="科目名称" field="subjectName" fixed="left" width="15%">
          <!-- //科目余额跳转明细 -->
          <template #default="{row}">
            <router-link class="text-hover primary-color" @success="loadList()" width="1400px"
                          v-if="row.subjectId"
                          :to="{name:'DetailedAccounts',params:{subjectIds:row.subjectId,start:params.start,end:params.end}}">
              {{ row.subjectName }}
            </router-link>
          </template>
        </vxe-column>
        <vxe-colgroup title="期初余额" align="center">
          <vxe-column title="借方数量" field="beginDebitQuantity" align="right" width="6.25%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ formatQuantity(row.beginQuantity) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="借方金额" field="beginningDebitBalance" align="right" width="6.25%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ numFormat(row.beginBalance) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方数量" field="beginCreditQuantity" align="right" width="6.25%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ formatQuantity(row.beginQuantity) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方金额" field="beginningCreditBalance" align="right" width="6.25%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ numFormat(row.beginBalance) }}</span>
            </template>
          </vxe-column>
        </vxe-colgroup>
        <vxe-colgroup title="本期发生额" align="center">
          <vxe-column title="借方数量" field="debitQuantity" align="right" :formatter="['toQuantity', quantityRadio]" width="6.25%"/>
          <vxe-column title="借方金额" field="debit" align="right" formatter="toMoney" width="6.25%"/>
          <vxe-column title="贷方数量" field="creditQuantity" align="right" :formatter="['toQuantity', quantityRadio]" width="6.25%"/>
          <vxe-column title="贷方金额" field="credit" align="right" formatter="toMoney" width="6.25%"/>
        </vxe-colgroup>
        <!-- <vxe-colgroup title="本年累计发生额" align="center">
          <vxe-column title="借方" field="yearTotalDebit" align="right" formatter="toMoney" width="120"/>
          <vxe-column title="贷方" field="yearTotalCredit" align="right" formatter="toMoney" width="120"/>
        </vxe-colgroup> -->
        <vxe-colgroup title="期末余额" align="center">
          <vxe-column title="借方数量" field="endDebitQuantity" align="right" width="6.25%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ formatQuantity(row.endQuantity) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="借方金额" field="endingDebitBalance" align="right"
                      :class-name="({row})=>row.endBalance<0?'red-color':''" width="6.25%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ numFormat(row.endBalance) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方数量" field="endCreditQuantity" align="right" width="6.25%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ formatQuantity(row.endQuantity) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方金额" field="endingCreditBalance" align="right"
                      :class-name="({row})=>row.endBalance<0?'red-color':''" width="6.25%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ numFormat(row.endBalance) }}</span>
            </template>
          </vxe-column>
        </vxe-colgroup>
      </vxe-table>



      <vxe-table :show-overflow="false"
                 :tree-config="{transform: false, rowField: 'treeId', parentField: 'parentTreeId',expandAll: true}"
                 show-footer
                 height="auto" 
                 :footer-method="calcTotal"
                 :loading="loading" ref="xTable" :data="dataList" border v-if="showYearTotal && showNum">
        <vxe-column title="科目编码" field="subjectCode" fixed="left" tree-node width="8%"></vxe-column>
        <vxe-column title="科目名称" field="subjectName" fixed="left" width="12%">
          <!-- //科目余额跳转明细 -->
          <template #default="{row}">
            <router-link class="text-hover primary-color" @success="loadList()" width="1400px"
                          v-if="row.subjectId"
                          :to="{name:'DetailedAccounts',params:{subjectIds:row.subjectId,start:params.start,end:params.end}}">
              {{ row.subjectName }}
            </router-link>
          </template>
        </vxe-column>
        <vxe-colgroup title="期初余额" align="center">
          <vxe-column title="借方数量" field="beginDebitQuantity" align="right" width="5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ formatQuantity(row.beginQuantity) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="借方金额" field="beginningDebitBalance" align="right" width="5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ numFormat(row.beginBalance) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方数量" field="beginCreditQuantity" align="right" width="5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ formatQuantity(row.beginQuantity) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方金额" field="beginningCreditBalance" align="right" width="5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ numFormat(row.beginBalance) }}</span>
            </template>
          </vxe-column>
        </vxe-colgroup>
        <vxe-colgroup title="本期发生额" align="center">
          <vxe-column title="借方数量" field="debitQuantity" align="right" :formatter="['toQuantity', quantityRadio]" width="5%"/>
          <vxe-column title="借方金额" field="debit" align="right" formatter="toMoney" width="5%"/>
          <vxe-column title="贷方数量" field="creditQuantity" align="right" :formatter="['toQuantity', quantityRadio]" width="5%"/>
          <vxe-column title="贷方金额" field="credit" align="right" formatter="toMoney" width="5%"/>
        </vxe-colgroup>
        <vxe-colgroup title="本年累计发生额" align="center">
          <vxe-column title="借方数量" field="yearTotalDebitQuantity" align="right" :formatter="['toQuantity', quantityRadio]" width="5%"/>
          <vxe-column title="借方金额" field="yearTotalDebit" align="right" formatter="toMoney" width="5%"/>
          <vxe-column title="借方数量" field="yearTotalCreditQuantity" align="right" :formatter="['toQuantity', quantityRadio]" width="5%"/>
          <vxe-column title="贷方金额" field="yearTotalCredit" align="right" formatter="toMoney" width="5%"/>
        </vxe-colgroup>

        <vxe-colgroup title="期末余额" align="center">
          <vxe-column title="借方数量" field="endDebitQuantity" align="right" width="5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ formatQuantity(row.endQuantity) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="借方金额" field="endingDebitBalance" align="right"
                      :class-name="({row})=>row.endBalance<0?'red-color':''" width="5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='借'">{{ numFormat(row.endBalance) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方数量" field="endCreditQuantity" align="right" width="5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ formatQuantity(row.endQuantity) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="贷方金额" field="endingCreditBalance" align="right"
                      :class-name="({row})=>row.endBalance<0?'red-color':''" width="5%">
            <template #default="{row}">
              <span v-if="row.balanceDirection==='贷'">{{ numFormat(row.endBalance) }}</span>
            </template>
          </vxe-column>
        </vxe-colgroup>
      </vxe-table>
      </div>
    </div>
  </app-content>
</template>

<script>
import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import AccountDateRangeChoose from "@/components/AccountDateRangeChoose";
import {clone} from "xe-utils";
import {VXETable} from "vxe-table";
import setting from "@/api/setting";

export default {
  name: "SubjectBalance",
  components: {AccountDateRangeChoose},
  data() {
    return {
      quantityRadio: 2,//格式化数量
      quantity: [{ title: '2位', key: 2 },{ title: '4位', key: 4 },{ title: '6位', key: 6 }],//格式化数量
      isBalanceZero:false,//jxd余额为0不显示
      isBalanceZeroAndOccur:false,//jxd余额为0且无发生额不显示
      subjectList: [],
      dataList: [],
      accountDate: null,
      showNum:false,
      showNumPrice: false,
      showYearTotal:false,
      showYearTotalDis:false,
      loading: false,
      params: {
        start: null,
        end: null,
        currencyId: null,
        levelStart: 1,
        levelEnd: 4,
        subjectStart: null,
        subjectEnd: null,
      },
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
          /* 表尾单元格样式 */
          .vxe-table tfoot td {
            border: 1px solid #000;
            font-size: 12px;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>科目余额表</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>编制单位：${this.currentAccountSets.companyName}</span>
                <span> ${this.title} </span>
                <span> 单位：元 </span>
            </div>
          `;
          const footerHtml = ``;
          return `${headerHtml}${content}${footerHtml}`;
        },
      },
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    title() {
			if (!this.params.start) {
				return '';
			}
			if (this.params.start === this.params.end) {
        this.showYearTotalDis = false;
				return manba(this.params.start).format("YYYY年MM期")
			}
      //jxd跨年强制不允许查看本年累计
      if(manba(this.params.start).year() != manba(this.params.end).year()){
        this.showYearTotalDis = true;this.showYearTotal = false;
      }else{
        this.showYearTotalDis = false;
      }
			return manba(this.params.start).format("YYYY年MM期") + " - " + manba(this.params.end).format("YYYY年MM期");
		},
    topData() {
      return this.dataList.filter(val => val.parentTreeId === '0');
    }
  },
  watch: {
    accountDate() {
      this.loadList();
    },
    showNumPrice() {
      this.loadList();
    }
  },
  methods: {
    //格式化数量
    formatQuantity(quantity) {
      return VXETable.formats.get('toQuantity')({ cellValue: quantity }, this.quantityRadio);
    },
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.params.start);
      let endDate = new Date(this.params.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
    },
    processFilter() {
      this.$nextTick(() => {
        const isBalanceZeroAndOccur = this.isBalanceZeroAndOccur;
        const isBalanceZero = this.isBalanceZero;
        let filterFn;
        if (isBalanceZeroAndOccur) {
          filterFn = val => val.debit != 0 || val.credit != 0 || val.endBalance != 0;
        } else if (isBalanceZero) {
          filterFn = val => val.endBalance != 0;
        } else {
          return this.loadList();
        }
        const filteredDataList = this.dataList.filter(filterFn);
        this.dataList = filteredDataList;
      });
    },
    // balanceZeroAndOccur(){
    //   this.$nextTick(() => {
    //     if(this.isBalanceZeroAndOccur){
    //       let arr = this.dataList.filter(val => val.debit != 0 || val.credit != 0 || val.endBalance != 0);
    //       this.dataList = arr;
    //     }else if(this.isBalanceZero){
    //       this.balanceZero();
    //     }else{
    //       this.loadList();
    //     }
    //   });
    // },
    // balanceZero(){
    //   this.$nextTick(() => {
    //     if(this.isBalanceZero){
    //       let arr = this.dataList.filter(val => val.endBalance != 0);
    //       this.dataList = arr;
    //     }else if(this.isBalanceZeroAndOccur){
    //       this.balanceZeroAndOccur();
    //     }else{
    //       this.loadList();
    //     }
    //   });
    // },
    printData() {
      // 获取VXE-Table实例
      const xTable = this.$refs.xTable;
      // 调用打印方法，并传入打印配置
      xTable.print({
        ...this.tablePrint,
      });
    },
    loadList() {
      this.loading = true;
      this.isBalanceZero = false;
      this.isBalanceZeroAndOccur = false;
      accountbook.loadSubjectBalance(Object.assign({
        showNumPrice: this.showNumPrice
      }, this.params)).then(({data}) => {
        this.loading = false;
        this.dataList = data;
        this.$refs.paramsDropdown.hide()
      });
    },
    sfilter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    exportData() {
      const utils = new BooUtil(this.$refs.xTable, '\n')
      accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
        downloadBlob(`${this.title}-科目余额表.xls`, data)
      })
    },
    resetForm() {
      this.params = clone(this.cloneParams, true)
    },
    calcTotal({ columns, data }) {
  const row = [];
  columns.forEach(col => {
    // 👇 全部改用整数运算，避免浮点数精度丢失
    if ('beginningDebitBalance' === col.property) {
      let total = this.topData.filter(val => val.balanceDirection === '借').reduce((total, r) => {
        return total + Math.round((r.beginBalance || 0) * 100)
      }, 0) / 100
      row.push(this.numFormat(total));
    } else if ('beginningCreditBalance' === col.property) {
      let total = this.topData.filter(val => val.balanceDirection === '贷').reduce((total, r) => {
        return total + Math.round((r.beginBalance || 0) * 100)
      }, 0) / 100
      row.push(this.numFormat(total));
    } else if ('endingDebitBalance' === col.property) {
      let total = this.topData.filter(val => val.balanceDirection === '借').reduce((total, r) => {
        return total + Math.round((r.endBalance || 0) * 100)
      }, 0) / 100
      row.push(this.numFormat(total));
    } else if ('endingCreditBalance' === col.property) {
      let total = this.topData.filter(val => val.balanceDirection === '贷').reduce((total, r) => {
        return total + Math.round((r.endBalance || 0) * 100)
      }, 0) / 100
      row.push(this.numFormat(total));
    } else if ('beginCreditQuantity' === col.property) {
      let total = this.topData.filter(val => val.balanceDirection === '贷').reduce((total, r) => {
        return total + Math.round((r.beginQuantity || 0) * 100)
      }, 0) / 100
      row.push(this.numFormat(total));
    } else if ('beginDebitQuantity' === col.property) {
      let total = this.topData.filter(val => val.balanceDirection === '借').reduce((total, r) => {
        return total + Math.round((r.beginQuantity || 0) * 100)
      }, 0) / 100
      row.push(this.numFormat(total));
    } else if ('endCreditQuantity' === col.property) {
      let total = this.topData.filter(val => val.balanceDirection === '贷').reduce((total, r) => {
        return total + Math.round((r.endQuantity || 0) * 100)
      }, 0) / 100
      row.push(this.numFormat(total));
    } else if ('endDebitQuantity' === col.property) {
      let total = this.topData.filter(val => val.balanceDirection === '借').reduce((total, r) => {
        return total + Math.round((r.endQuantity || 0) * 100)
      }, 0) / 100
      row.push(this.numFormat(total));
    } else if (!['subjectCode', 'subjectName'].includes(col.property)) {
      let total = this.topData.reduce((total, r) => {
        return total + Math.round((r[col.property] || 0) * 100)
      }, 0) / 100
      row.push(this.numFormat(total));
    } else {
      row.push(col.property === "subjectName" ? '合计' : "")
    }
  })
  return [row];
},
  },
  created() {
    this.params.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.params.end = this.params.start;
    this.params.currencyId = this.localCurrency.id;
    this.cloneParams = clone(this.params, true)
    // setting.subject.voucherSelect().then(({data}) => {
    //   this.subjectList = data;
    // })
    //jxd这里的科目选择应该是所有科目
    setting.subject.listAll().then(({data}) => {
      this.subjectList = data;
    })
    this.loadList();
  }
}
</script>

<style scoped lang="less">
.balance {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 0 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
    height: 32px;

    &.tip {
      background-color: #FFEEEF;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f8fbf8;
  }

  tbody tr:hover {
    background-color: #F0F6FF;
  }

  .header {
    td {
      background-color: #F5F5F5;
      text-align: center;
      font-weight: bold;
      height: 35px;
    }
  }
}
</style>
